import { render } from "./ListRoles.vue?vue&type=template&id=7a92b95c"
import script from "./ListRoles.vue?vue&type=script&lang=js"
export * from "./ListRoles.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__